import 'rxjs/add/operator/map';

import { Injectable } from '@angular/core';

import { ApiProvider } from '../api/api';
import { VehicleMakeModel } from './../../models/vehicle-make';

@Injectable()
export class VehicleProvider {
  constructor(private api: ApiProvider) {}

  get vehicleIdTypes(): IDType[] {
    return [
      {
        type: 'vin',
        longLabel: 'VIN',
        shortLabel: 'VIN',
      },
      {
        type: 'license',
        longLabel: 'License Number',
        shortLabel: 'License',
      },
      {
        type: 'serial_number',
        longLabel: 'Serial Number',
        shortLabel: 'Serial',
      },
    ];
  }

  getCarMakes() {
    return this.api
      .call({
        url: '/vehicle_makes',
      })
      .map(makes => makes.map(make => new VehicleMakeModel(make)))
      .map(makes => this.sortCarMakes(makes));
  }

  private sortCarMakes(makes) {
    return makes.sort(function(a, b) {
      if (a.make < b.make) return -1;
      if (a.make > b.make) return 1;
      return 0;
    });
  }

  getCarModels(makeUID: string) {
    return this.api
      .call({
        url: '/vehicle_makes/' + makeUID,
      })
      .map(make => this.sortCarModels(make.vehicle_models));
  }

  private sortCarModels(models) {
    return models.sort(function(a, b) {
      if (a.model < b.model) return -1;
      if (a.model > b.model) return 1;
      return 0;
    });
  }
}

export interface IDType {
  type: string;
  shortLabel: string;
  longLabel: string;
}



// WEBPACK FOOTER //
// ./src/providers/vehicle/vehicle.ts